import React from 'react';

export const registrationCategories = {
  active_strict_eligible: 'Active, strict-dispatch eligible',
  active_missing_ownership: 'Active, missing ownership evidence',
  active_otherwise_ineligible: 'Active, otherwise ineligible',
  inactive_or_unset: 'Inactive or unset active status',
};

export function matchesRegistrationFilter(report, filter) {
  if (filter === 'all') return true;
  if (!report) return false;
  const counts = report.counts || {};
  if (filter === 'excluded') return (counts.active_missing_ownership || 0) + (counts.active_otherwise_ineligible || 0) > 0;
  return (counts[filter] || 0) > 0;
}

const evidenceFlag = value => value === true ? 'Yes' : value === false ? 'No' : 'Not established';
export default function PushRegistrationEvidence({ report }) {
  if (!report) return <span>Registration evidence unavailable</span>;
  return <div className="min-w-[260px] text-xs">
    {Object.entries(registrationCategories).map(([key, label]) => <div key={key}>{label}: {report.counts?.[key] || 0}</div>)}
    {report.registrations?.length > 0 && <details className="mt-2">
      <summary className="cursor-pointer underline">Registration details ({report.registrations.length})</summary>
      {report.registrations.map((row, index) => <div className="mt-2 border-t pt-2" key={row.reference || index}>
        <div>Reference: {row.reference || 'Unavailable'}</div>
        <div>{registrationCategories[row.category] || 'Classification unavailable'}</div>
        <div>Platform: {row.platform}; environment: {row.environment}; status: {row.active_status}</div>
        <div>Reasons: {row.reasons?.length ? row.reasons.map(reason => reason.replace(/_/g, ' ')).join(', ') : 'None observed'}</div>
        <div>Generation evidence: {evidenceFlag(row.generation_present)}; device evidence: {evidenceFlag(row.device_evidence_present)}</div>
        <div>Authoritative bindings match: {evidenceFlag(row.authoritative_bindings_match)}</div>
        <div>Reported app version: {row.app_version || 'Not stored / unavailable'}</div>
        <div>Created: {row.created_at || 'Unavailable'}</div>
        <div>Updated: {row.updated_at || 'Unavailable'}</div>
      </div>)}
    </details>}
  </div>;
}
